import {FC} from 'react';
import {Box, Flex} from '@chakra-ui/react';
import {Badge, JsonViewer} from 'ui-kit';

import 'react-json-view-lite/dist/index.css';

interface IProps {
  name: string;
  args: object;
}

export const ToolSlot: FC<IProps> = ({name, args}) => {
  return (
    <Flex pl={'16px'} flexDirection={'column'} gap={'4px'}>
      <Box>
        <Badge variant={'success'}>Tool call · {name}</Badge>
      </Box>
      <Box px={'2px'}>
        <JsonViewer args={args} />
      </Box>
    </Flex>
  );
};
